import SlimSelect from 'slim-select';

const initSlimSelect = () => {
  const customSelects = document.querySelectorAll('.custom-select');
  customSelects.forEach((selectElement) => {
    if (!!selectElement.dataset.ssid || selectElement.tagName !== 'SELECT') {
      return;
    }
    new SlimSelect({
      select: selectElement,
      showSearch: false,
      placeholder: 'Выбрать из списка',
      allowDeselect: true,
    });

    const otherInput = document.querySelector('input#other_field');

    if (otherInput) {
      otherInput.removeAttribute('data-required');

      selectElement.addEventListener('change', (e) => {
        const options = e.target.querySelectorAll('option');
        const selectedOption = [...options].find((el) => el.selected);

        if (selectedOption) {
          const xmlID = selectedOption.dataset.xmlId;
          const otherBlock = document.querySelector('#other');

          if (xmlID === 'other') {
            otherBlock.style.display = 'flex';
            otherInput.setAttribute('data-required', 'text');
          } else {
            otherBlock.style.display = 'none';
            otherInput.removeAttribute('data-required');
          }
        }
      });
    }
  });

  const customSelectsLocation = document.querySelectorAll(
    '.custom-select-location',
  );
  customSelectsLocation.forEach((selectElement) => {
    if (!!selectElement.dataset.ssid || selectElement.tagName !== 'SELECT') {
      return;
    }
    new SlimSelect({
      select: selectElement,
      showSearch: true,
      allowDeselect: true,
      placeholder: 'Выбрать город',
      searchPlaceholder: 'Найти город',
    });
  });

  const customSelectsNoDelete = document.querySelectorAll(
    '.custom-select--no-delete',
  );
  customSelectsNoDelete.forEach((selectElement) => {
    if (!!selectElement.dataset.ssid || selectElement.tagName !== 'SELECT') {
      return;
    }
    new SlimSelect({
      select: selectElement,
      showSearch: false,
    });
  });

  const catalogSelects = document.querySelectorAll('.custom-select--catalog');
  catalogSelects.forEach((selectElement) => {
    if (!!selectElement.dataset.ssid || selectElement.tagName !== 'SELECT') {
      return;
    }
    new SlimSelect({
      select: selectElement,
      showSearch: false,
      placeholder: 'Сортировать по:',
      allowDeselect: true,
    });

    selectElement.addEventListener('change', (e) => {
      e.preventDefault();

      if (e.target.value) {
        window.location.href = e.target.value;
      } else {
        queueMicrotask(() => {
          window.location.href = window.location.href.replace(`${window.location.search}`, '');
        });
      }
    });
  });
};

window.initSlimSelect = initSlimSelect;

const customSelect = () => {
  initSlimSelect();
  const customSelectBlocks = document.querySelectorAll('.custom-select');
  if (customSelectBlocks.length) {
    customSelectBlocks.forEach((customSelectBlock) => {
      const parent = customSelectBlock.closest('.js-form');
      let otherInput = null;
      let otherInputTheme = null;

      if (parent) {
        otherInput = parent.querySelector('input.other');
        otherInputTheme = parent.querySelector('input.other_theme');
      }

      if (otherInput) {
        otherInput.removeAttribute('data-required');

        customSelectBlock.addEventListener('change', (e) => {
          const options = e.target.querySelectorAll('option');
          const selectedOption = [...options].find((el) => el.selected);

          if (selectedOption) {
            const xmlID = selectedOption.dataset.xmlId;
            const otherBlock = document.querySelector('#other');

            if (xmlID === 'other') {
              otherBlock.style.display = otherInput.classList.contains('_is-flex') ? 'flex' : 'block';
              otherInput.setAttribute('data-required', 'text');
            } else {
              otherBlock.style.display = 'none';
              otherInput.removeAttribute('data-required');
            }
          }
        });
      }

      if (otherInputTheme) {
        otherInputTheme.removeAttribute('data-required');

        customSelectBlock.addEventListener('change', (e) => {
          const options = e.target.querySelectorAll('option');
          const selectedOption = [...options].find((el) => el.selected);

          if (selectedOption) {
            const xmlID = selectedOption.dataset.xmlId;
            const otherBlock = document.querySelector('#other_theme');

            if (xmlID === 'other') {
              otherBlock.style.display = otherInputTheme.classList.contains('_is-flex') ? 'flex' : 'block';
              otherInputTheme.setAttribute('data-required', 'text');
            } else {
              otherBlock.style.display = 'none';
              otherInputTheme.removeAttribute('data-required');
            }
          }
        });
      }
    });
  }
};

customSelect();
window.customSelect = customSelect;
